import React, { useState } from 'react';
import { shape, string } from 'prop-types';
import { Form } from 'semantic-ui-react';
import { SingleDatePicker } from 'react-dates';
import SimpleTimeInput from './SimpleTimeInput';
import moment from 'moment';
import styles from './DateTimePicker.less';

const DateTimePicker = (props) => {
  const {
    label,
    field: { name, value },
    form: { setFieldValue, touched, errors },
  } = props;

  const [dateValue, setDateValue] = useState(moment(value));
  const [timeValue, setTimeValue] = useState(moment(value).format('HH:mm'));

  const [focusedValue, setFocusedValue] = useState(false);

  const onFocusChange = ({ focused }) => {
    setFocusedValue(focused);
  };

  const onDateChange = (date) => {
    setDateValue(date);

    if (date) {
      const clonedValue = moment(date);
      const oldTime = moment(value, 'HH:mm');

      clonedValue.set({
        hour: oldTime.get('hour'),
        minute: oldTime.get('minute'),
      });
      setFieldValue(name, clonedValue);
    } else {
      setFieldValue(name, null);
    }
  };

  const handleTimeChange = (newTime) => {
    setTimeValue(newTime);

    const time = moment(newTime, 'HH:mm');
    if (time.isValid()) {
      const clonedValue = moment(value);

      clonedValue.set({
        hour: time.get('hour'),
        minute: time.get('minute'),
      });

      setFieldValue(name, clonedValue);
    }
  };

  return (
    <Form.Field>
      <div className={styles.label}>{label}</div>
      <div className={styles.inputContainer}>
        <SingleDatePicker
          id="single-date-picker"
          date={dateValue}
          focused={focusedValue}
          placeholder="MM/DD/YYYY"
          onDateChange={onDateChange}
          onFocusChange={onFocusChange}
          numberOfMonths={1}
          hideKeyboardShortcutsPanel
          enableOutsideDays
        />

        <SimpleTimeInput
          value={timeValue}
          onChange={handleTimeChange}
          className={styles.simpleTimeInput}
        />
      </div>

      {
        touched[name]
        && errors[name]
        && <div className={styles.errors}>{errors[name]}</div>
      }
    </Form.Field>
  );
};

DateTimePicker.propTypes = {
  label: string,
  field: shape({}).isRequired,
  form: shape({}).isRequired,
};

DateTimePicker.defaultProps = {
  label: '',
};

export default DateTimePicker;
